/*global $*/
import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import { movil } from "../app-movil";
import isMobile from "ismobilejs";

// import PolizaForm from './poliza.frm';

const mapState = (state) => {
	return {
		correo: state.olvide.correo,
		url: state.olvide.url
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoAnterior: () => {
			console.log("a");
			dispatch({ "type": "OLVIDE_SET_CORREO", "correo": "" });
			dispatch({ "type": "OLVIDE_PASO_ANTERIOR" });
		},
		resetPaso: () => {
			dispatch({ "type": "OLVIDE_RESET_PASO" });
		}
	};
};



class RevisaCorreo extends React.Component {
	
	componentDidMount(){
		
		//modal-revisa-correo
		$("#modal-revisa-correo").modal("show");
	}
	
	regresar = () => {
		$("#modal-revisa-correo").modal("toggle");
		let mensaje = {"return": "login", "procesa": "recupera"};
		movil("cambiarcontrasena", mensaje);
		this.props.resetPaso();
		goTo("login");
		//window.location.href = '/#!/login';
	}

	render() {
		return( 
		<div className="modal fade modal-msj" id="modal-revisa-correo" tabIndex="-1" role="dialog" aria-labelledby="modal-revisa-correo" data-backdrop="static" data-keyboard="false">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
				  
				 
					<div className="login-form">
						<div className="h1-titulo text-center">Revisa tu correo electrónico</div>
						<div className="mt-70 text-center">
							<p>Haz clic en el enlace que te enviamos para restablecer tu contraseña.</p>
							<p>Si no ves el correo electrónico en tu bandeja de entrada revisa otras <br className="hide-mobile" />carpetas como spam.</p>
							{/*<p>Liga Temporal: <a onClick={this.getUrl}>Aquí</a></p>*/}
						</div>
						<div className="mt-70"><button onClick={this.regresar} className="orange-rectangle">Aceptar</button></div>
						<div className="gray-text text-right mt-70"> {/*No he recibido el correo.<a className="black-text" onClick={this.props.pasoAnterior}>Reenviar</a>*/}</div>
					</div>
		
				</div>
			</div>
		</div>);
	}
}

export default connect(mapState, mapDispatch)(RevisaCorreo);


// WEBPACK FOOTER //
// ./src/gnp-olvide/revisaCorreo.cmpt.js